import React, { createContext, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth as useAuthHook } from '../hooks/useAuth';

// Create the Auth Context
const AuthContext = createContext(null);

// Auth Provider Component - wraps the routes that need auth
export function AuthProvider({ children }) {
  const authValue = useAuthHook(); // Single instance of useAuth
  const navigate = useNavigate();
  const location = useLocation();

  // Handle navigation when user becomes null (logged out)
  useEffect(() => {
    // Only redirect if we're sure the user is logged out (not just initial null state)
    // and we're not already on a public auth-related page (login, forgot, reset, etc.)
    const path = location.pathname || '';
    const isAuthPublicRoute =
      path === '/login' ||
      path.startsWith('/forgot') ||
      path.startsWith('/reset') ||
      path.startsWith('/check-email') ||
      path.startsWith('/reset-confirmation');

    if (authValue.user === null && !isAuthPublicRoute && localStorage.getItem('token') === null) {
      navigate('/login', { replace: true });
    }
  }, [authValue.user, navigate, location.pathname]);
  return <AuthContext.Provider value={authValue}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

// Custom hook to use the Auth Context
// Custom hook to use the Auth Context
export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
